<template>
  <BoxWrapper class="overflow-visiblez-20' hover:z-10'">
    <div
      class="flex py-2.5 md:py-3 px-2.5 md:px-4 items-center justify-between space-x-3"
    >
      <div
        class="flex items-center justify space-x-2 relative w-3/4 break-word lg:break-normal"
      >
        <button
          v-if="isPackage"
          @click="handleOpenStatus"
          class="p-1 flex-shrink-0 w-7"
          aria-label="expand"
        >
          <img
            src="@/assets/images/base/icons/angle-down.svg"
            class="transform"
            :class="isOpen ? 'rotate-180' : 'rotate-0'"
            loading="lazy"
          />
        </button>
        <div class="space-x-2 flex items-center">
          <a
            :href="serviceUrl"
            class="text-sm md:text-base text-primary font-bold hover:underline hover:text-primaryLight"
          >
            {{ examination.name }}
          </a>

          <div class="inline-flex items-center flex-shrink-0">
            <Popover
              v-if="examination.for_own_package"
              class="font-medium inline-flex items-center"
            >
              <PopoverButton
                class="bottom-0 h-5 w-5 md:w-6 md:h-6 relative z-20 cursor-pointer shrink-0"
                aria-label="info"
              >
                <img
                  src="@/assets/images/base/icons/for_own_package.svg"
                  class="shrink-0 inline"
                  loading="lazy"
                />
              </PopoverButton>
              <PopoverPanel
                class="absolute top-4 bg-white shadow-md z-30 rounded-lg p-4 text-sm left-0 min-w-[70vw] sm:min-w-[350px] max-w-xs text-primary mt-2"
              >
                <div class="max-h-44 overflow-y-auto">
                  <p>{{ $t("own_packages.own_package_info") }}</p>
                </div>
              </PopoverPanel>
            </Popover>
          </div>
        </div>
      </div>

      <div class="w-1/4 text-right">
        <span
          v-if="examination"
          class="text-primary font-medium whitespace-nowrap text-sm md:text-base"
        >
          {{ examination.price }} {{ this.currency }}
        </span>
      </div>

      <div class="flex items-center justify-end w-[120px]">
        <button
          v-show="isAddedByDoctor && !checkRequireAdditional"
          :disabled="isAddedByDoctor"
          class="rounded-3xl bg-primary h-10 w-[120px] flex justify-between items-center transition-ease-in-out border border-neutral-60 opacity-60 p-px"
          :class="isMobile ? '' : 'space-x-3'"
        >
          <span class="text-sm font-medium text-white ml-4">
            {{ $t("referrals.added") }}
          </span>
          <div
            class="flex items-center justify-center rounded-full w-9 h-9 shrink-0 bg-white mr-px"
          >
            <img src="@/assets/images/base/icons/check.svg" loading="lazy" />
          </div>
        </button>

        <button
          v-show="!isActive && !isAddedByDoctor && !checkRequireAdditional"
          @click="manageExamination"
          :disabled="isAddedByDoctor"
          class="rounded-3xl bg-white h-10 w-[120px] pr-0 lg:pr-4 flex items-center transition-ease-in-out space-x-3 border border-neutral-60 hover:opacity-70 p-px"
        >
          <div
            class="flex items-center justify-center rounded-full w-9 h-9 shrink-0 bg-blue"
          >
            <img src="@/assets/images/base/icons/plus.svg" loading="lazy" />
          </div>

          <span class="text-sm font-medium text-blue">
            {{ $t("action.add") }}
          </span>
        </button>

        <!-- jeden pacjent -->
        <button
          v-if="
            isActive &&
            !isAddedByDoctor &&
            !checkRequireAdditional &&
            this.patients.length <= 1
          "
          class="rounded-3xl bg-primary h-10 w-[120px] pl-0 flex items-center transition-ease-in-out space-x-3 border border-primary"
          :class="[
            allPatientHasAddedExamination
              ? 'lg:pl-4 justify-end'
              : 'justify-between',
            this.patients.length <= 1
              ? 'hover:bg-primaryLight cursor-pointer'
              : 'cursor-default',
          ]"
          @click="handleRemoveExamination"
        >
          <div
            v-if="!isMobile && !allPatientHasAddedExamination"
            class="flex items-center justify-center rounded-full w-9 h-9 shrink-0 hover:bg-primaryLight bg-primary border-white border-solid border-2 cursor-pointer"
            @click="manageExamination"
          >
            <img src="@/assets/images/base/icons/plus.svg" loading="lazy" />
          </div>

          <span
            class="text-sm font-medium text-white"
            v-if="allPatientHasAddedExamination"
          >
            {{ $t("referrals.added") }}
          </span>
          <div
            class="flex items-center justify-center rounded-full w-9 h-9 shrink-0 bg-white mr-px"
          >
            <img src="@/assets/images/base/icons/check.svg" loading="lazy" />
          </div>
        </button>

        <!-- kilku pacjentów -->
        <button
          v-if="
            isActive &&
            !isAddedByDoctor &&
            !checkRequireAdditional &&
            this.patients.length > 1
          "
          class="rounded-3xl bg-primary h-10 w-[120px] pl-0 flex items-center transition-ease-in-out space-x-1 border border-primary hover:opacity-70 duration-200"
          @click="manageExamination"
        >
          <div
            class="flex items-center justify-center rounded-full w-9 h-9 shrink-0 bg-white border-white border-solid border-2 cursor-pointer"
          >
            <img
              src="@/assets/images/base/icons/plus-darkblue.svg"
              loading="lazy"
            />
          </div>

          <span class="text-sm font-medium text-white whitespace-nowrap">
            {{ $t("referrals.added") }} ({{ patientsWithGivenExamination }})
          </span>
        </button>
      </div>
    </div>
    <div v-if="isPackage && isOpen" class="py-3 px-4">
      <ul
        class="pl-6 text-primary text-sm md:text-base font-bold list-points-line"
      >
        <li
          v-for="examination in examination.examinations"
          :key="examination"
          class="pl-6 text-left pb-2"
        >
          {{ examination }}
        </li>
      </ul>
    </div>
  </BoxWrapper>
</template>

<script>
import BoxWrapper from "@/components/Core/BoxWrapper.vue";
import isMobile from "@/mixins/isMobile";
import gtmExaminationMixin from "@/mixins/gtmExaminationMixin";
import { mapActions, mapGetters, mapMutations } from "vuex";
import { Popover, PopoverButton, PopoverPanel } from "@headlessui/vue";

export default {
  name: "CoreExaminationBox",
  components: { BoxWrapper, Popover, PopoverButton, PopoverPanel },
  props: ["examination", "type", "patientReferral"],
  mixins: [isMobile, gtmExaminationMixin],
  data() {
    return {
      isOpen: false,
    };
  },

  computed: {
    serviceUrl() {
      return `${this.landingPageUrl}/${this.isPackage ? "pakiet" : "badanie"}/${
        this.examination.slug
      }`;
    },
    isPackage() {
      return this.type === "package";
    },
    patientsWithGivenExamination() {
      return this.getExaminationPatients(this.examination.id)?.length;
    },
    allPatientHasAddedExamination() {
      return (
        this.getExaminationPatients(this.examination.id)?.length ===
        this.patients?.length
      );
    },
    isActive() {
      return this.selectedEaminationIds.includes(this.examination.id);
    },
    checkRequireAdditional() {
      if (
        this.examination.require_covid_nursing_services &&
        this.requireAdditional?.name === "upiel"
      ) {
        return true;
      } else if (
        this.examination.require_nursing_services &&
        this.requireAdditional?.name === "upielc"
      ) {
        return true;
      } else return false;
    },
    isAddedByDoctor() {
      return this.getIsAddedByDoctor(this.examination.id);
    },
    ...mapGetters({
      getIsAddedByDoctor: "cart/getExaminationAddedByDoctor",
      requireAdditional: "cart/getAdditionalServices",
      patientsIds: "checkout/getPatientsIds",
      patients: "checkout/getPatients",
      selectedEaminationIds: "cart/getExaminationIds",
      getExaminationPatients: "cart/getExaminationPatients",
      isEnabledFeature: "features/isEnabled",
      getDiscount: "cart/getDiscount",
      getDiscountForAll: "cart/getDiscountForAll",
      personalData: "checkout/getPersonalData",
    }),
  },
  methods: {
    manageExamination() {
      if (this.patients.length <= 1) {
        this.manageCart({
          examination: this.examination,
          patients: this.patientsIds ?? [],
        });

        this.gtmAddToCart(this.examination);
      } else {
        this.setSelectedExamination(this.examination);
        this.openModal("addPatientModal");
      }

      if (
        !["Examinations", "Packages", "OwnPackages", "SearchServices"].includes(
          this.$route.name
        )
      ) {
        this.$router.push({ name: "Examinations" });
      }
    },
    handleRemoveExamination() {
      if (this.patients.length <= 1) {
        let discount = 0;

        if (this.patients.length === 0) {
          discount = this.getDiscountForAll;
        } else {
          discount = this.getDiscount(this.patients[0].id);
        }

        if (this.examination.for_own_package && discount === 5) {
          this.openModalCallback({
            name: "confirmModal",
            title: `<div class="text-center">${this.$t(
              "cart.attention"
            )}</div>`,
            text: `<div class="text-primary text-center">${this.$t(
              "cart.loss_of_already_accrued_discounts_alert"
            )}</div>`,
            onConfirm: () => {
              this.manageCart({
                examination: this.examination,
                patients: [],
              });
              this.gtmRemoveFromCart(
                this.examination,
                this.personalData?.email
              );
            },
          });
        } else {
          this.manageCart({
            examination: this.examination,
            patients: [],
          });
          this.gtmRemoveFromCart(this.examination, this.personalData?.email);
        }
      }
    },
    handleOpenStatus() {
      this.isOpen = !this.isOpen;
    },
    ...mapMutations({
      openModal: "modals/openModal",
      setSelectedExamination: "cart/setSelectedExamination",
      openModalCallback: "modals/openModalCallback",
    }),
    ...mapActions({
      manageCart: "cart/manageCart",
    }),
  },
};
</script>
